import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';

/**
 * Model Hub is still in preview, so its label carries a "(preview)" suffix. The suffix lives in a
 * dedicated translation key rather than being appended at render time, so the localized strings
 * stay grammatical. Once Model Hub goes GA, turn on EnableAiTrustLayerModelHubGaLabel, then delete
 * this hook, the flag and the CLIENT_AI_TRUST_LAYER_MODEL_HUB_TAB string, and inline
 * CLIENT_AI_TRUST_LAYER_MODEL_HUB_GA at the call sites.
 */
export const useModelHubTitleKey = () => {
    const EnableAiTrustLayerModelHubGaLabel = useFeatureFlagValue(Features.EnableAiTrustLayerModelHubGaLabel.name);

    return EnableAiTrustLayerModelHubGaLabel
        ? 'CLIENT_AI_TRUST_LAYER_MODEL_HUB_GA'
        : 'CLIENT_AI_TRUST_LAYER_MODEL_HUB_TAB';
};
